var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M527.529 -15.5286L256 -287.058L-15.529 -15.5286L256 256L527.529 -15.5286Z",
    fill: "#27AE60"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M256 256.001L-15.5288 -15.5283L-287.058 256.001L-15.5288 527.53L256 256.001Z",
    fill: "#222222"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M799.058 256.001L527.529 -15.5283L256 256.001L527.529 527.53L799.058 256.001Z",
    fill: "#222222"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M527.529 527.529L256 256L-15.529 527.529L256 799.058L527.529 527.529Z",
    fill: "#27AE60"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2612 -30.3779L-30.3784 33.2617L478.738 542.379L542.378 478.739L33.2612 -30.3779Z",
    fill: "#F1C40F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M542.378 33.2617L478.738 -30.3779L-30.3785 478.739L33.2611 542.379L542.378 33.2617Z",
    fill: "#F1C40F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJm);
export default __webpack_public_path__ + "static/media/JM.d1345e175a52bea4c04c1ad27eb7b7d3.svg";
export { ForwardRef as ReactComponent };